import jQuery from 'jquery'
import Flickity from 'flickity'
import 'flickity-imagesloaded'
import {debounce} from './helpers'
import {hideTeasers} from './teasers'
import {checkStandardTableIsEmpty} from './standards'

const CELL_SELECTOR = [
  ".product-box:not(.cell-hidden)",
  ".postcard:not(.cell-hidden)",
  ".product-variant:not(.cell-hidden)",
  ".teaser-large:not(.hidden)",
  ".teaser-small:not(.hidden)"
].join()

/**
 * Get total length of Flickity cells
 * @param {Element} element
 * @return {Number}
 */
function getSliderCellsLength(element) {
  const cells = Array.from(element.querySelectorAll(CELL_SELECTOR))
  return cells.reduce((total, cell) => total + cell.scrollWidth + 1, 1)
}

/**
 * Initialize Flickity on a given element
 * @param {Element} element
 * @param {String} filterGroup
 */
function flickitySlider(element,filterGroup) {
    var isWiderThanViewport = getSliderCellsLength(element) >= window.innerWidth &&
      filterGroup !== 'product-variants' && filterGroup !== 'teasers'

  return new Flickity(element, {
    contain: true,
    pageDots: false,
    imagesLoaded: true,
    cellSelector: CELL_SELECTOR,
    wrapAround: isWiderThanViewport,
    prevNextButtons: isWiderThanViewport,
    draggable: isWiderThanViewport,
    on: {
      ready: function () {
        this.element.classList.add('flickity-resize')
      }
    }
  })
}

/**
 * Handle filter groups.
 * @example <caption>Expected HTML markup</caption>
 * <div data-filter-group="filterGroupID">
 * 	<button class="button active" data-filter="*">All</button>
 * 	<button data-filter="a">Filter A</button>
 * </div>
 *
 * <div data-filter-target="filterGroupID">
 * 	<div data-groups='["a"]'>Target A</div>
 * 	<div data-groups='["a", "b"]'>Target AB</div>
 * 	<div data-groups='["c"]'>Target C</div>
 * </div>
 */
export function applyFilter(event, onPageLoad = false) {
  return (function ($) {
    const filterGroup = $(event.delegateTarget).data('filterGroup')
    const $filterGroup = $('[data-filter-group=' + filterGroup + ']')
    const $filterTarget = $('[data-filter-target=' + filterGroup + ']')
    const $filterElements = $filterTarget.find('[data-groups]')

    const filterValue = (event.type === 'change')
      ? $filterGroup.find('[data-filter]:selected').data('filter')
      : $(event.currentTarget).data('filter')

    if (!$filterTarget.length) {
      console.log(`No filter target found for "${filterGroup}"`)
      return
    }

    if (!$filterElements.length) {
      console.log(`No filter elements found in "${filterGroup}" target`)
      return
    }

    $filterGroup.find('[data-filter]').removeClass('active')

    var $filterGroupFilter = $filterGroup.find(
      '[data-filter="' + CSS.escape(filterValue) + '"]'
    )

    if ($filterGroupFilter.length) {
      $filterGroupFilter.addClass('active')
    } else {
      $(event.currentTarget).addClass('active')
    }

    // set pulldown value if filtering is triggered by image map
    var optionalPulldown = $('[data-filter-group=' + filterGroup + ']').find('[data-filter-select]');
    if (optionalPulldown.length === 1) {
      optionalPulldown[0].value = filterValue;
    }

    var flkty = Flickity.data($filterTarget[0])

    const debounceHideTeasers = debounce(() => {
      if (filterGroup === 'teasers') {
        hideTeasers(filterValue)
      }
    }, 20)

    const debounceCheckStandardTableIsEmpty = debounce(() => {
      if (filterGroup === 'standards') {
        checkStandardTableIsEmpty($filterTarget)
      }
    }, 20)

    $filterElements.each(function () {
      var values = $(this).data('groups')

      if (filterValue === '*' || values.indexOf(filterValue) > -1) {
        if (flkty) {
          $(this).removeClass('cell-hidden')
        }
        $(this).fadeIn(450, () => { debounceHideTeasers();debounceCheckStandardTableIsEmpty() })
      } else {
        const event = new Event('hide')

        if (flkty) {
          $(this).addClass('cell-hidden')
          $(this).hide(() => {
            this.dispatchEvent(event)
          })
        } else {

          if (filterGroup == 'sections-filter') {
            if ($(this).hasClass('sectionsFilter0') || $(this).hasClass('sectionsFilter1') || $(this).hasClass('sectionsFilter3')) {
              $(this).fadeOut(450, () => {
                this.dispatchEvent(event)
              })
            }
          }
          else {
            $(this).fadeOut(450, () => {
              this.dispatchEvent(event)
              debounceHideTeasers()
              debounceCheckStandardTableIsEmpty()
            })
          }
        }
      }
    })

    if (flkty) {
      flkty.destroy()
      flickitySlider($filterTarget.get(0), filterGroup)
    }

    if (!onPageLoad && filterGroup === 'sections-filter') {
      // same iteration as on page load excluding sections filter
      // so that the filterable components like product sliders show all elements
      $('[data-filter-group]').each(function () {
        var filterGroup = $(this).data('filterGroup')
        if (filterGroup !== 'sections-filter') {
          var $filterGroup = $('[data-filter-group=' + filterGroup + ']')
          applyFilter({
            delegateTarget: $filterGroup[0],
            currentTarget: $filterGroup.find('[data-filter].active')[0],
          })
        }
      })
    }
  })(jQuery)
};

(function ($) {

  /**
   * Initialize flickity sliders
   */
  $('[data-filter-slider]').each(function() {
    flickitySlider(this)
  })

  /**
   * Initialize filter groups
   */
  $('[data-filter-group]').on('click', '[data-filter]', handleFilterRequest)
  $('[data-filter-group]').on('change', '[data-filter-select]', handleFilterRequest)

  function handleFilterRequest(event) {
    var filterGroup = $(event.delegateTarget).data('filterGroup')
    var $filterTarget = $('[data-filter-target=' + filterGroup + ']')

    applyFilter(event)

    // Prevent default action
    var currentTargetHref = $(event.currentTarget).attr('href')
    if (currentTargetHref && currentTargetHref.startsWith('#')) {
      event.preventDefault()
    }

    // A click event may be triggered on the homepage after an ajax call on page load.
    // So scrolling down to the "postcards" section is not desired in this context.
    // See ../js/homepage.js
    if (filterGroup === 'postcard') {
      $('html, body').stop().animate({
      }, 300, 'swing')
      return
    }

    // Scroll to the target if it is not visible
    var offsetTop = $('.header').height() || 0
    var scrollTop = $(window).scrollTop() + offsetTop
    var windowHeight = $(window).height()
    var targetOffset = $filterTarget.offset().top
    var targetHeight = $filterTarget.height()

    var isBelow = targetOffset + (windowHeight / 4) >= scrollTop + windowHeight
    var isAbove = targetOffset + targetHeight <= scrollTop

    if (isBelow || isAbove) {
      var $filterGroup = $filterTarget.parents('.section-wrap').prev('[data-filter-group=' + filterGroup + ']')
      var filterGroupHeight = $filterGroup.length ? targetOffset - $filterGroup.offset().top : 0;

      scrollTop = targetOffset - (offsetTop + filterGroupHeight)
      if (targetHeight + filterGroupHeight < windowHeight - offsetTop) {
        scrollTop -= (windowHeight - offsetTop - targetHeight - filterGroupHeight) / 2
      }

      $('html, body').stop().animate({
        scrollTop: scrollTop
      }, 300, 'swing')
    }
  }

  // This function jumps to window.location.hash after all filters have been applied
  const debouncedScrollToHash = debounce(() => {
    if (window.location.hash) {
      var offsetTop = $('.header').height() || 0
      var scrollTop = $(window.location.hash).offset().top - offsetTop

      $('html, body').stop().animate({
        scrollTop: scrollTop
      }, 300, 'swing')
    }
  }, 1000)

  /**
   * Apply filter on page load
   */
  $('[data-filter-group]').each(function () {
    var filterGroup = $(this).data('filterGroup')
    var $filterGroup = $('[data-filter-group=' + filterGroup + ']')

    let currentTarget = ($filterGroup.find('select').length > 0)
      ? $filterGroup.find('[data-filter]:selected')[0]
      : $filterGroup.find('[data-filter].active')[0]

    applyFilter({
      delegateTarget: $filterGroup[0],
      currentTarget: currentTarget,
    }, true)

    debouncedScrollToHash()
  })

  /**
   * Tracking
   */
  window.dataLayer = window.dataLayer || { push: console.log }

  let doTrack = true;
  const LOCAL_DOMAINS = ["localhost", "127.0.0.1", "local.dehn-international.com","local.dehn.de","dev.dehn-international.com","dev.dehn.de","test.dehn-international.com","test.dehn.de"];

  if (LOCAL_DOMAINS.includes(window.location.hostname)) {
    doTrack = false;
  }

  if (doTrack) {
    // Track product clicks
    $('.product-box .ic-plus').on('click', function () {
      var $parent = $(this).parents('.product-box')
      var label =
        $parent.find('h4').text().trim() +
        ' - ' +
        $parent.find('p.smallest').text().trim()
      window.dataLayer.push({
        event: 'clickEvent',
        eventCategory: $(this)
          .parents('[data-filter-target]')
          .data('filterTarget'),
        eventAction: 'Merkliste',
        eventLabel: label,
      })
    })

    $('.product-box .ic-burger').on('click', function () {
      var $parent = $(this).parents('.product-box')
      var label =
        $parent.find('h4').text().trim() +
        ' - ' +
        $parent.find('p.smallest').text().trim()
      window.dataLayer.push({
        event: 'clickEvent',
        eventCategory: $(this)
          .parents('[data-filter-target]')
          .data('filterTarget'),
        eventAction: 'Details',
        eventLabel: label,
      })
    })

    // Track flickity previous and next button clicks
    $('.flickity-button').on('click', function () {
      var isNext = $(this).hasClass('next')
      var category = $(this)
        .parents('[data-filter-target]')
        .data('filterTarget')

      window.dataLayer.push({
        event: 'clickEvent',
        eventCategory: category,
        eventAction: 'Arrow',
        eventLabel: isNext ? 'Rechts' : 'Links',
      })
    })
  }

})(jQuery)
